// Цветът на наличността в „Целият списък": няма (≤ 0) · под минимума ·
// нормална. Минимумът е `minQuantity` на продукта; без минимум няма „ниска".
// `isBelowMinimum` е чипът „Под минимума" (и празното, ако има минимум).
import type { CatalogStockTone } from "./CatalogPickerModal";

export const catalogStockTone = (quantity: number, minQuantity?: number | null): CatalogStockTone =>
  quantity <= 0 ? "none" : minQuantity != null && quantity < minQuantity ? "low" : "ok";

export const isBelowMinimum = (quantity: number, minQuantity?: number | null): boolean =>
  minQuantity != null && minQuantity > 0 && quantity < minQuantity;
